<template>
  <div>
  <b-row class="justify-content-center" style="width: 101.1%; height: 50px; overflow: hidden; background: white;">
      <div class="col-md-12">
     <a href="/">
      <img :src="logo" style="width: 190px; padding: 10px 20px;">
    </a>
      </div>
    </b-row>

    <div
      class="app flex-row align-items-center"
      v-bind:style="{
        'background-image': 'url(' + bg_img + ') !important',
        'min-height': '92vh',
        'background-repeat': 'repeat-x !important',
      }"
    >
      <div class="container">
        <b-row class="justify-content-center">
          <b-col md="6" sm="8">
            <b-card no-body class="mx-4">
              <b-card-body class="p-4">
                <div class="row">
                  <div
                    class="col-md-12 alert alert-success"
                    role="alert"
                    v-if="hasErrors.message"
                    data-dismiss="alert"
                  >
                    <strong
                      ><small>{{ errorMessage.message }}</small></strong
                    >
                  </div>
                </div>
                <h1>Enter password</h1>

                <small class="help-block" v-if="hasErrors.email"
                  ><strong style="color: red"
                    >{{ errorMessage.email }}
                  </strong></small
                >

                <small class="help-block" v-if="hasErrors.number"
                  ><strong style="color: red"
                    >{{ errorMessage.number }}
                  </strong></small
                >
                <b-input-group
                  class="mb-3"
                  :class="{ 'has-error': hasErrors.number }"
                >
                  <b-input-group-prepend> </b-input-group-prepend>
                  <b-input-group class="mb-3">
                    <p>
                      IN +91{{ registerData.number
                      }}<b-button
                        type="button"
                        variant="link"
                        class="px-4"
                        @click.prevent="showphonenumber()"
                      ></b-button>
                    </p>
                  </b-input-group>
                </b-input-group>

                <small class="help-block" v-if="hasErrors.password"
                  ><strong style="color: red">{{
                    messagepassword
                  }}</strong></small
                >
                <b-input-group
                  class="mb-3"
                  :class="{ 'has-error': hasErrors.password }"
                >
                  <b-input-group-prepend>
                    <b-input-group-text
                      ><i class="icon-lock"></i
                    ></b-input-group-text>
                  </b-input-group-prepend>
                  <input
                    type="password"
                    class="form-control"
                    id="password"
                    placeholder="Password"
                    v-model="registerData.password"
                    name="password"
                    required
                    autocomplete="off"
                  />
                </b-input-group>

                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text
                      ><i class="icon-lock"></i
                    ></b-input-group-text>
                  </b-input-group-prepend>
                  <input
                    type="password"
                    class="form-control"
                    id="confirmpassword"
                    placeholder="Confirm password"
                    v-model="registerData.confirmpassword"
                    name="confirmpassword"
                    required
                    autocomplete="off"
                  />
                </b-input-group>

                <small class="help-block" v-if="hasErrors.agree"
                  ><strong style="color: red"
                    >{{ errorMessage.agree }}
                  </strong></small
                >

                <b-button
                  type="button"
                  variant="primary"
                  @click.prevent ="registerPost();"
                  >Submit</b-button
                >
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
       <Spinner v-if="loading"></Spinner>
      </div>
    </div>
  </div>
</template>

<script>
import Spinner from "../../spinner.vue";
export default {
  components: {
    Spinner,
  },
  data() {
    return {
      logo: null,
      bg_img: null,
      planModal: false,
      selplan: "0",
      plan_dt: null,
      plan_dt_save: {},
      termModal: false,
      privacyModal: false,
      loading: false,
      cityopt: [],
      city: null,
      warningModal: false,
      warningModal1: false,
      resetemail: "",
      resetpassword: "",
      resettoken: "",
      resetpasswordconf: "",
      checkwarningmodel1: "",
      varificationuser: false,
      customertoken: "",
      customerdata: [],
      Verifiednumber: false,
      NewOTPGenerator: false,
      Continueview: true,
      registerData: {
        number: "",
        password: "",
      },
      hasErrors: {
        message: false,
        number: false,
        password: false,
        agree: false,
      },
      messagepassword: "",
      errorMessage: {
        message: null,
        number: null,
        password: null,
      },
    };
  },
  created() {
    this.logo = this.baseURL2 + "/design/img/logo.png";
    this.bg_img = this.baseURL2 + "/design/img/ban1.jpg";
    var is_remember = this.getCookie("is_remember");
    var username = this.getCookie("nummber");

    if (is_remember == "true") {
      this.remember = true;
      this.loginData.number = username;
    }

    this.test();
  },
  methods: {
    getCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    test() {
      this.logo = this.baseURL2 + "/design/img/logo.png";
      this.bg_img = this.baseURL2 + "/design/img/ban1.jpg";
      var is_remember = this.getCookie("is_remember");
      // var company_id = this.getCookie('company_id')
      var username = this.getCookie("username");

      if (is_remember == "true") {
        this.remember = true;
        this.loginData.both = username;
      }

      var Number = JSON.parse(localStorage.getItem("customerphonenumber"));
      this.registerData.number = Number;
    },
    showphonenumber() {
      this.$router.props = [this.customerdata.cust_cmp_phone];
      localStorage.setItem("customerphonenumber", "");
    },

    registerPost() {
      var submit_true = 0;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      var _this = this;
      var vm = this.hasErrors;
      var _vm = this.errorMessage;
      var pass =
        /^((?!.*[\s])(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%]).{8,20})$/;

      _this.hasErrors.number = false;
      _this.hasErrors.email = false;
      _this.hasErrors.agree = false;

      if (this.registerData.password === this.registerData.confirmpassword) {
        vm.password = false;
        var regex = /^[a-zA-Z0-9\s]{3,100}$/;
        var uregex = /^[a-zA-Z\s]{3,100}$/;
        var prex = /^[0-9]{10,15}$/;
        var eregex =
          /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[A-Za-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;

        if (
          this.registerData.password != this.registerData.confirmpassword ||
          this.registerData.password == ""
        ) {
          _this.hasErrors.password = true;
          _this.errorMessage.password =
            "Password & ConfirmPassword Does Not Match";
          submit_true = 1;
        }

        if (pass.test(this.registerData.password) == false) {
          vm.password = true;
          _this.messagepassword =
            "8 characters including 1 uppercase letter, 1 special character & alphanumeric characters without space";
          submit_true = 1;
        }

        if (this.registerData.agree == false) {
          vm.agree = true;
          _this.errorMessage.agree = "Required";
          submit_true = 1;
        }

        if (submit_true == 0) {
          var data = {
            phonenumber: this.registerData.number,
            password: this.registerData.password,
            // txt_pass: this.registerData.password,
          };
          var res;
          // console.log(data.password)
          var poss= data.password
          // console.log(poss)
          localStorage.setItem(
        "password",
        JSON.stringify(poss)
      );
          this.loading = true;
          this.$http
            .post("/api/customers/setpassword", data)
            .then(function (response) {
              if (response.status === 200) {
              //  this.method1();
              var Number = JSON.parse(localStorage.getItem("customerphonenumber"));
              var password1 = JSON.parse(localStorage.getItem("password"));
              // console.log(Number)
              // console.log(password1)
              // console.log('pass@123')
              var phone= Number
              var password= password1
              // console.log(phone)
              // console.log(password)
              var customertoken = null;
              // console.log('custoken')
              // console.log(customertoken)
              var log={
                 phone : Number,
                 password : password1,
                 customertoken: customertoken,
              }
              // console.log(log)
               _this.$http
                  .post("/api/customers/customerlogin", log)
                  .then(function (response) {
                    if (response.status === 200) {
                      console.log('okkk')
                      _this.$store.dispatch("setUserObject", response.data.id);
                      localStorage.setItem("authUser", response.data.cust_cmp_phone);
                      localStorage.setItem(
                        "authUserid",
                        response.data.customer_phone
                      );

                      _this.$store.commit("set_is_admin", false);

                      // localStorage.setItem('authUserstatus', status)
                      _this.$router.push("/customerdetails");
                      _this.loading = false;
                    } else if (response.status === 401) {
                      _this.loading = false;
                    } else {
                      _this.loading = false;
                    }
                  })
                  .catch(function (error) {
                    console.log("error");
                    console.log(error);
                    _this.loading = false;
                    vm.message = true;
                    _vm.message = error.response.data.error.message;
                  });
              } else {
                console.log("unknown");
              }
            })

            .catch(function (error) {
              //  console.log(error)
              _this.loading = false;
              var errors = error.response;
              console.log(errors);
              if (errors.statusText === "Unprocessable Entity") {
                if (errors.data) {
                  if (error.response.data.error.details.messages.number) {
                    vm.number = true;
                    _vm.number =
                      error.response.data.error.details.messages.number[0];
                  }
                  if (error.response.data.error.details.messages.password) {
                    vm.password = true;
                    _vm.password =
                      error.response.data.error.details.messages.password[0];
                  }
                }
              } else if (errors.statusText === "unknown") {
                if (errors.status === 455) {
                  alert("password is already registered .");
                }
              }
            });
        }
      } else {
        vm.password = true;
        _this.messagepassword = "Password & ConfirmPassword Does Not Match";
      }
    },
    // method1(){
    //     var submit_true = 0;
     
    //   var _this = this;
    //   var vm = this.hasErrors;
    //   var _vm = this.errorMessage;
    //   var pass =
    //     /^((?!.*[\s])(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%]).{8,20})$/;

    //   _this.hasErrors.number = false;
    //   _this.hasErrors.email = false;
    //   _this.hasErrors.agree = false;

    //   if (this.registerData.password === this.registerData.confirmpassword) {
    //     vm.password = false;
    //     var regex = /^[a-zA-Z0-9\s]{3,100}$/;
    //     var uregex = /^[a-zA-Z\s]{3,100}$/;
    //     var prex = /^[0-9]{10,15}$/;
    //     var eregex =
    //       /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[A-Za-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;

    //     if (
    //       this.registerData.password != this.registerData.confirmpassword ||
    //       this.registerData.password == ""
    //     ) {
    //       _this.hasErrors.password = true;
    //       _this.errorMessage.password =
    //         "Password & ConfirmPassword Does Not Match";
    //       submit_true = 1;
    //     }

    //     if (pass.test(this.registerData.password) == false) {
    //       vm.password = true;
    //       _this.messagepassword =
    //         "8 characters including 1 uppercase letter, 1 special character & alphanumeric characters without space";
    //       submit_true = 1;
    //     }

    //     if (this.registerData.agree == false) {
    //       vm.agree = true;
    //       _this.errorMessage.agree = "Required";
    //       submit_true = 1;
    //     }

    //     if (submit_true == 0) {
           
    //             console.log("else verification user condition");
    //             this.customertoken = null;
                
    //             var _this = this;
    //             var vm = this.hasErrors;
    //             var _vm = this.errorMessage;

    //             this.loading = true;

    //             var log = {
    //               phone: this.registerData.number,
    //               password: this.registerData.password,
    //               customertoken: this.customertoken,
    //             };
    //             if (this.remember) {
    //               document.cookie = "is_remember=true";
    //               document.cookie = "username=" + this.registerData.number;
    //             } else {
    //               document.cookie = "is_remember=false";
    //               document.cookie = "username=";
    //             }

    //             this.$http
    //               .post("/api/customers/customerlogin", log)
    //               .then(function (response) {
    //                 if (response.status === 200) {
    //                   _this.$store.dispatch("setUserObject", response.data.id);
    //                   localStorage.setItem("authUser", response.data.id);
    //                   localStorage.setItem(
    //                     "authUserid",
    //                     response.data.customer_id
    //                   );

    //                   _this.$store.commit("set_is_admin", false);

    //                   // localStorage.setItem('authUserstatus', status)
    //                   _this.$router.push("/customerdetails");
    //                   _this.loading = false;
    //                 } else if (response.status === 401) {
    //                   _this.loading = false;
    //                 } else {
    //                   _this.loading = false;
    //                 }
    //               })
    //               .catch(function (error) {
    //                 console.log("error");
    //                 console.log(error);
    //                 _this.loading = false;
    //                 vm.message = true;
    //                 _vm.message = error.response.data.error.message;
    //               });
          

          
    //     }
    //   } else {
    //     vm.password = true;
    //     _this.messagepassword = "Password & ConfirmPassword Does Not Match";
    //   }
      
    // }
  },
};
</script>
<style scoped>
@media only screen and (max-width: 768px) {
  /* For mobile phones: */
  [class*="col-"] {
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/goldcustomers/setpassword.vue